import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const API_URL = "https://emphasoft-test-assignment.herokuapp.com";

export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: {},
    users: {}
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token, user) {
      state.status = "success";
      state.token = token;
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
    },
    set_users(state, users) {
      state.users = users;
      state.status = "success";
    }
  },
  actions: {
    login({ commit }, user) {
      let username = user.username;
      let password = user.password;
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: API_URL + "/api-token-auth/",
          method: "POST",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          data: JSON.stringify({
            username,
            password
          })
        })
          .then(resp => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", token);
            commit("auth_success", token, user);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit("logout");
        localStorage.removeItem("token");

        resolve();
      });
    },
    getUsers({ commit }) {
      commit("auth_request");
      return new Promise((resolve, reject) => {
        axios
          .get(API_URL + "/api/v1/users/", {
            headers: {
              Authorization: `Token ${this.state.token}`
            }
          })
          .then(resp => {
            const users = resp.data;
            console.log(users);
            commit("set_users", users);
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    usersList: state => state.users
  }
});
